





































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PopSettingsVO } from '@/types/pop';
import { isEnablePrivacySetting } from '@/utils/experiment';

@Component({
  name: 'EmbeddedPopup'
})
export default class EmbeddedPopup extends Vue {
  @Prop({ required: true }) formData!: PopSettingsVO;

  @Prop({ required: true }) activePageSetting!: string;

  @Prop(String) couponCopyText!: string;

  get currentCouponCode() {
    if (this.formData.discountType === 'dongtai' || !!this.formData.discount) {
      return this.$t('views.wheeloffortune.pop.text_52a86001663e793a') as string;
    }
    const couponCode = this.formData.rules.couponCode || 'coupon code';
    return couponCode;
  }

  get currentCouponCopy() {
    return this.couponCopyText || 'Copy';
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  mounted() {
    // console.log(this.formData);
  }

  @Watch('formData', { deep: true })
  onFormDataChange(newVal: PopSettingsVO) {
    // console.log(newVal);
  }

  get formStyle() {
    const rules = this.formData.rules;
    return `
      .cartx-embedded-form .cartx-embedded-form-input {
        border-width: ${rules.inputType === 'bottom' ? '0 0 1px 0' : '1px'} !important;
        border-style: ${rules.inputBorderStyle} !important;
        border-color: ${rules.inputBorderColor} !important;
        border-radius: ${rules.inputBorderRadius} !important;
        background: ${rules.inputBackgroundShow !== 'none' ? rules.inputBackground : 'none'} !important;
        color: ${rules.inputColor} !important;
      }
      .cartx-embedded-form input::-webkit-input-placeholder {
        color: ${rules.inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-moz-placeholder {
        color: ${rules.inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input::-moz-placeholder {
        color: ${rules.inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-ms-input-placeholder {
        color: ${rules.inputColor} !important;
        opacity: .3;
      }
    `;
  }

  defineUrl(url?: string) {
    if (url?.indexOf('https://') == -1 && url?.indexOf('http://') == -1) {
      return 'http://' + url;
    } else {
      return url;
    }
  }
}
